/**
 * Canonical FORGE sourcing status → label + colour, shared across the cockpit
 * header, the cockpit tender list, and the My Tenders funnel so the funnel reads
 * the same everywhere. Mirrors the backend `_sourcing_status` in forge/main.py.
 *
 * "ready" is the milestone: every line item has an awarded quote AND the pricing/
 * compliance gate passes — the signal to build the final bid and hand to Manifest.
 */
export const SOURCING_STATUS = {
  preparing: { label: 'Preparing', short: 'Prep', color: '#6b7785' },
  sourcing: { label: 'Sourcing', short: 'Sourcing', color: '#2563eb' },
  quoting: { label: 'Quoting', short: 'Quoting', color: '#d97706' },
  review: { label: 'Needs review', short: 'Review', color: '#dc2626' },
  ready: { label: 'Ready to submit', short: 'Ready', color: '#16a34a' },
  submitted: { label: 'Submitted', short: 'Submitted', color: '#7c3aed' },
};

export const statusMeta = (key) => SOURCING_STATUS[key] || SOURCING_STATUS.preparing;

export default SOURCING_STATUS;
